import { useQuery } from "@tanstack/react-query";

export type PublicConfig = {
  recaptcha: {
    enabled: boolean;
    siteKey: string;
  };
};

const fallbackConfig: PublicConfig = {
  recaptcha: {
    enabled: false,
    siteKey: "",
  },
};

export function usePublicConfig() {
  return useQuery<PublicConfig>({
    queryKey: ["/api/public-config"],
    staleTime: 10 * 60 * 1000,
    queryFn: async () => {
      const response = await fetch("/api/public-config", {
        credentials: "include",
      });

      if (!response.ok) {
        return fallbackConfig;
      }

      return response.json();
    },
  });
}
